export const TAU = Math.PI * 2;
export const DEGREES_PER_RADIAN = 360 / TAU;
